module.exports = __webpack_public_path__ + "img/img11.440ba82e.svg";